import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MailCheck } from "lucide-react";

export const VerifyEmailSent = ({ email, isOfferteIntent, onResend }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
    <div className="w-full max-w-md text-center" data-testid="verify-email-sent">
      <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
        <MailCheck className="w-7 h-7 text-green-600" />
      </div>
      <h1 className="font-display text-3xl font-extrabold text-slate-950 mb-3">Bevestig je e-mailadres</h1>
      <p className="text-sm text-slate-600 leading-relaxed mb-2">
        We hebben een bevestigingslink gestuurd naar <strong>{email}</strong>.
        Klik op de link in die e-mail om je account te activeren — daarna kun je inloggen
        {isOfferteIntent ? " en is je offerteaanvraag al verstuurd naar de gekozen bedrijven." : "."}
      </p>
      <p className="text-xs text-slate-400 mb-6">Geen e-mail ontvangen? Controleer je spam of vraag een nieuwe link aan.</p>
      <div className="flex flex-col gap-2">
        <Button data-testid="resend-verification-btn" onClick={() => onResend(email)} variant="outline" className="rounded-sm font-semibold border-slate-300">
          Verstuur de link opnieuw
        </Button>
        <Link to="/inloggen" data-testid="go-to-login-link" className="text-orange-600 font-semibold hover:underline text-sm mt-2">Naar inloggen</Link>
      </div>
    </div>
  </div>
);
